import React from 'react';
import { ChannelConnectionProps } from './ChannelConnection';
import { useCurrentStateByControlUnitId } from '../../../../../redux/controlUnit/hooks/useCurrentStateByControlUnitId';
import { Base64 } from '../../../../../util/Base64';
import { useShowErrorMessage } from '../../../../../handlingErrors';
import { Skeleton } from '@mui/material';
import { ChannelDetail } from './ChanelPanel';
import { getValueWithPreferredUnitAndDecimals } from '../../../../../redux/controlUnit/api/util/sensor/formatValues';
import usePreferredTemperatureUnit from '../../../../../redux/settings/hooks/usePreferredTemperatureUnit';

function ChannelSensor(props: ChannelConnectionProps) {
  const { channel } = props;
  const {
    channel: channelId = '',
    controlUnitId = '',
    deviceId: commanderId = '',
  } = channel || {};

  const { currentSensorData, loading, ...rest } =
    useCurrentStateByControlUnitId(commanderId, controlUnitId);

  const sensor = currentSensorData?.[channelId];
  const sensorValue = sensor?.value;
  const sensorUnit =
    sensor?.metadata?.unitString ?? sensor?.metadata?.unit ?? '';

  const { data: preferredTemperatureUnit } = usePreferredTemperatureUnit();
  const { value, unit } = getValueWithPreferredUnitAndDecimals(
    sensorValue,
    sensorUnit,
    0,
    preferredTemperatureUnit
  );

  return (
    <>
      {loading && sensorValue == undefined ? (
        <Skeleton variant="text" width={'100%'} component={'span'} />
      ) : (
        <ChannelDetail
          title={channel?.name ?? ''}
          value={value}
          unit={unit}
          {...props}
        />
      )}
    </>
  );
}

export default ChannelSensor;
